import { gql } from 'apollo-angular';

const REQUEST_ADDITIONAL_OFFERS = gql`
  mutation requestAdditionalOffer(
    $rfpId: Long!
    $responseDueDate: Date!
    $sellerIds: [Long!]!
  ) {
    requestAdditionalOffer(
      additionalOfferRequest: {
        rfpId: $rfpId
        responseDueDate: $responseDueDate
        sellerIds: $sellerIds
      }
    ) {
      recipients {
        seller {
          id
          name
        }
        offerSubmissionStatistics {
          newSubmissionsCount
          lastSubmissionDate
        }
        status
        offers {
          id
          name
          status
          submissionDate
          sellerId
        }
      }
      offersDueDate
    }
  }
`;

export default REQUEST_ADDITIONAL_OFFERS;
